import {t} from 'i18next';
import AurDialog, {DialogProps} from '../../common/aur-dialog/AurDialog';

interface QueryBuilderClearConfirmationAlertProps {
  showDialog: DialogProps['showDialog'];
  onOk: DialogProps['onOk'];
  onCancel: DialogProps['onCancel'];
}

const QueryBuilderClearConfirmationAlert = ({
  showDialog,
  onCancel,
  onOk,
}: QueryBuilderClearConfirmationAlertProps) => {
  return (
    <AurDialog
      showDialog={showDialog}
      className={'clear-confim-alert-cancel-dialog'}
      dialogTitle={t(
        'indexSearchPage.clearConfirmDialog.confirmClearSearch.justToConfirm'
      )}
      popupTitle={t('indexSearchPage.clearQueryBuilderDialog.title')}
      labelActionCancel={t('buttons.cancel')}
      labelActionOk={t('buttons.continue')}
      onOk={onOk}
      onCancel={onCancel}
    />
  );
};

export default QueryBuilderClearConfirmationAlert;
